import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

import RepairReportInspectionItemsTable from
  '#/modules/crmMgmt/aftersales/repairReport/components/RepairReportInspectionItemsTable';
import RepairReportMainInfoCard from
  '#/modules/crmMgmt/aftersales/repairReport/components/RepairReportMainInfoCard';
import CreateEditReferenceSection from '#/modules/infra/layout/CreateEditReferenceSection';

function displayOrDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

function SnapshotField({ label, value, preserveNewlines = false }) {
  return (
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p
        className={cn(
          'mt-0.5 text-gray-900 text-sm font-medium wrap-break-word',
          preserveNewlines && 'whitespace-pre-line',
        )}
      >
        {displayOrDash(value)}
      </p>
    </div>
  );
}

SnapshotField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  preserveNewlines: PropTypes.bool,
};

/** 維修報告編輯頁右欄：GET detail 唯讀快照（靜態，儲存 refetch 才更新）。 */
const RepairReportEditReferenceSections = ({ detail }) => {
  if (!detail) {
    return null;
  }

  const inspectionItems = detail?.inspectionItems
    ?? detail?.inspection?.inspectionItems
    ?? [];

  return (
    <>
      <CreateEditReferenceSection title="送修快照（唯讀）">
        <div className="grid grid-cols-1 gap-3">
          <SnapshotField label="產品序號" value={detail.serialNo} />
          <SnapshotField label="品名" value={detail.itemName} />
          <SnapshotField label="問題描述" value={detail.problemDescription} />
          <SnapshotField label="配件" value={detail.accessories} preserveNewlines />
        </div>
      </CreateEditReferenceSection>
      <CreateEditReferenceSection title="單據快照（唯讀）">
        <RepairReportMainInfoCard detail={detail} compact nested hideItemSnapshot />
      </CreateEditReferenceSection>
      <CreateEditReferenceSection title="檢測項目" flush>
        <RepairReportInspectionItemsTable items={inspectionItems} />
      </CreateEditReferenceSection>
    </>
  );
};

RepairReportEditReferenceSections.propTypes = {
  detail: PropTypes.object,
};

export default RepairReportEditReferenceSections;
